import ThemeToggle from "./ThemeToggle";
export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm px-4">
      <div className="container-fluid">
        <span className="navbar-brand fw-bold">Support Desk </span>
        <ThemeToggle />
      </div>
    </nav>
  );
}
